module.exports = __webpack_public_path__ + "images/emoji/clock530.b0acb46edd4ceab13ca3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/clock530.png
// module id = ByYQ
// module chunks = 14